<template>
    <div class="srv-fp-overlay" @click.self="$emit('fermer')">
        <div class="srv-fp">
            <div class="srv-fp-poignee"></div>

            <div class="srv-fp-scroll">
                <div class="srv-fp-head">
                    <h1 class="srv-fp-titre">{{ item.libelle }}</h1>
                    <button class="srv-icone-btn" aria-label="Fermer" @click="$emit('fermer')">
                        <i class="ri-close-line"></i>
                    </button>
                </div>

                <img v-if="photo" :src="photo" alt="" class="srv-fp-img" decoding="async" @error="photoKo = true" />

                <!-- PORTIONS - masqué s'il n'y a qu'un seul prix : proposer un
                     choix unique n'est pas un choix, c'est un clic de plus.
                     Le montant est DANS le libellé (« Portion de 2 500 FCFA »),
                     jamais répété à droite. -->
                <section v-if="lesTarifs.length > 1" class="srv-fp-bloc">
                    <div class="srv-fp-bloc-head">
                        <h2>Choisissez votre portion</h2>
                        <span class="srv-fp-mention obligatoire">Obligatoire</span>
                    </div>
                    <button v-for="t in lesTarifs" :key="t.pid"
                            class="srv-fp-portion" :class="{ active: tarifPid === t.pid }"
                            @click="tarifPid = t.pid">
                        <span class="srv-fp-radio"><span class="srv-fp-dot"></span></span>
                        <span class="srv-fp-portion-lbl srv-num">{{ t.libelle }}</span>
                    </button>
                </section>

                <!-- ACCOMPAGNEMENT - un seul, sans supplément (le référentiel
                     ne porte aucun prix, et la caisse ne les additionne jamais).
                     Le bloc ENTIER, titre compris, disparaît quand le plat n'en
                     propose pas : pas de titre orphelin, pas de placeholder. -->
                <section v-if="lesAccomp.length" class="srv-fp-bloc">
                    <div class="srv-fp-bloc-head">
                        <h2>Accompagnement</h2>
                        <span class="srv-fp-mention unique">Un seul</span>
                    </div>
                    <div class="srv-fp-chips">
                        <button v-for="a in lesAccomp" :key="a.pid"
                                class="srv-fp-chip" :class="{ active: accomp === a.name }"
                                @click="accomp = a.name">
                            {{ a.name }}
                        </button>
                    </div>
                </section>

                <!-- INGRÉDIENTS - ceux que la fiche technique du plat autorise à
                     retirer ou à doubler. Le bloc entier disparaît quand le
                     plat n'en a aucun. Le prix ne change pas. Le choix vaut
                     pour toute la quantité ajoutée : un plat différent
                     s'ajoute en rouvrant la fiche. -->
                <section v-if="lesIngredients.length" class="srv-fp-bloc">
                    <div class="srv-fp-bloc-head">
                        <h2>Ingrédients</h2>
                        <span class="srv-fp-mention unique">Sans supplément</span>
                    </div>
                    <div v-for="g in lesIngredients" :key="g.c" class="srv-fp-ing">
                        <span class="srv-fp-ing-nom">{{ g.name }}</span>
                        <div class="srv-fp-ing-choix">
                            <button class="srv-fp-ing-btn" :class="{ active: etatIng(g) === 'normal' }"
                                    @click="choisirIng(g, 'normal')">Normal</button>
                            <button v-if="g.r" class="srv-fp-ing-btn sans" :class="{ active: etatIng(g) === 'retire' }"
                                    @click="choisirIng(g, 'retire')">Sans</button>
                            <button v-if="g.d" class="srv-fp-ing-btn double" :class="{ active: etatIng(g) === 'double' }"
                                    @click="choisirIng(g, 'double')">Double</button>
                        </div>
                    </div>
                </section>

                <section class="srv-fp-bloc">
                    <div class="srv-fp-bloc-head"><h2>Un mot pour la cuisine ?</h2></div>
                    <textarea v-model="note" rows="2" maxlength="180"
                              placeholder="bien cuit, sans piment…"></textarea>
                </section>
            </div>

            <div class="srv-fp-cta">
                <div class="srv-fp-stepper">
                    <button aria-label="Retirer" @click="qte = Math.max(1, qte - 1)">
                        <i class="ri-subtract-line"></i>
                    </button>
                    <span class="srv-num">{{ qte }}</span>
                    <button aria-label="Ajouter" @click="qte = Math.min(50, qte + 1)">
                        <i class="ri-add-line"></i>
                    </button>
                </div>
                <button class="srv-btn srv-fp-ajouter" :disabled="!valide" @click="valider">
                    <span>Ajouter</span>
                    <span class="srv-fp-sep">·</span>
                    <span class="srv-num">{{ fmt(total) }}</span>
                </button>
            </div>
            <p v-if="!valide" class="srv-fp-err">{{ messageManquant }}</p>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import { fmt, tarifs, tarifDefaut, prixTarif } from "../menu/format";
    import { imagesActives, urlPhoto } from "@/service/imagesArticles";

    export default {
        name: "srvficheplat",
        props: { item: { type: Object, required: true } },
        emits: ["fermer", "confirmer"],
        // ing : état choisi par ingrédient, indexé par son code court (absent = normal).
        data: () => ({ tarifPid: "", accomp: "", note: "", qte: 1, ing: {}, photoKo: false }),
        computed: {
            // Photo du plat, si les images sont affichées sur cet appareil.
            photo() { return (!this.photoKo && imagesActives()) ? urlPhoto(this.item.photo) : ""; },
            lesTarifs() { return tarifs(this.item); },
            lesAccomp() { return this.item.accompagnement || []; },
            lesIngredients() { return this.item.ingredients || []; },
            tarifChoisi() { return this.lesTarifs.find((t) => t.pid === this.tarifPid) || null; },
            total() { return (this.tarifChoisi ? prixTarif(this.tarifChoisi) : 0) * this.qte; },
            // L'accompagnement n'est obligatoire que si le plat en propose.
            valide() {
                if (!this.tarifChoisi) return false;
                return this.lesAccomp.length ? !!this.accomp : true;
            },
            messageManquant() {
                if (!this.tarifChoisi) return "Choisissez une portion pour continuer.";
                return "Choisissez un accompagnement pour continuer.";
            },
        },
        methods: {
            fmt,
            etatIng(g) { return this.ing[g.c] || "normal"; },
            choisirIng(g, etat) { this.ing = Object.assign({}, this.ing, { [g.c]: etat }); },
            valider() {
                if (!this.valide) return;
                this.$emit("confirmer", {
                    item: this.item,
                    tarif: this.tarifChoisi,
                    accompagnement: this.accomp,
                    ingredients: this.lesIngredients
                        .filter((g) => this.etatIng(g) !== "normal")
                        .map((g) => ({ c: g.c, name: g.name, etat: this.etatIng(g) })),
                    note: this.note.trim(),
                    qte: this.qte,
                });
            },
        },
        mounted() {
            const t = tarifDefaut(this.item);
            this.tarifPid = t ? t.pid : "";
            // Un plat à accompagnement unique : on le présélectionne, le
            // serveur n'a rien à décider.
            if (this.lesAccomp.length === 1) this.accomp = this.lesAccomp[0].name;
            document.body.style.overflow = "hidden";
        },
        beforeUnmount() { document.body.style.overflow = ""; },
    };
</script>

<style scoped>
    .srv-fp-overlay {
        position: fixed; inset: 0; z-index: 90;
        background: rgba(0, 0, 0, .62);
        display: flex; align-items: flex-end; justify-content: center;
    }
    .srv-fp {
        width: 100%; max-width: 480px; max-height: 92dvh;
        display: flex; flex-direction: column;
        background: var(--srv-surface-low);
        border-top: 1px solid var(--srv-outline-variant);
        border-radius: 16px 16px 0 0;
        animation: srv-monte .22s cubic-bezier(.4, 0, .2, 1);
    }
    @keyframes srv-monte { from { transform: translateY(100%); } to { transform: none; } }

    .srv-fp-poignee {
        width: 38px; height: 4px; border-radius: 2px; margin: 10px auto 0;
        background: var(--srv-outline-variant); flex-shrink: 0;
    }

    .srv-fp-scroll { flex: 1; overflow-y: auto; padding: var(--srv-md) var(--srv-gutter); }

    .srv-fp-head { display: flex; align-items: flex-start; gap: var(--srv-sm); }
    .srv-fp-titre { flex: 1; margin: 4px 0 0; font-size: 22px; font-weight: 700; letter-spacing: -0.01em; }

    .srv-fp-img {
        display: block; width: 100%; max-height: 190px; object-fit: cover;
        margin-top: var(--srv-md); border-radius: var(--srv-r); background: var(--srv-surface-high);
    }

    .srv-fp-bloc { margin-top: var(--srv-lg); }
    .srv-fp-bloc-head {
        display: flex; align-items: center; justify-content: space-between;
        gap: var(--srv-sm); margin-bottom: var(--srv-sm);
    }
    .srv-fp-bloc-head h2 {
        margin: 0; font-size: 15px; font-weight: 700;
        letter-spacing: .02em; text-transform: uppercase;
    }
    .srv-fp-mention {
        padding: 3px 9px; border-radius: var(--srv-r-chip);
        font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em;
        white-space: nowrap;
    }
    .srv-fp-mention.obligatoire { background: var(--srv-warn-soft);    color: var(--srv-warn-on); }
    .srv-fp-mention.unique      { background: var(--srv-success-soft); color: var(--srv-primary); }

    .srv-fp-portion {
        display: flex; align-items: center; gap: 12px;
        width: 100%; min-height: 56px; padding: 0 14px; margin-bottom: var(--srv-sm);
        background: var(--srv-surface); color: var(--srv-on);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r);
        font-family: inherit; text-align: left; cursor: pointer;
    }
    .srv-fp-portion.active { border-color: var(--srv-primary); background: var(--srv-primary-soft); }
    .srv-fp-portion-lbl { font-size: 16px; font-weight: 600; }

    .srv-fp-radio {
        width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
        border: 2px solid var(--srv-outline);
        display: flex; align-items: center; justify-content: center;
    }
    .srv-fp-portion.active .srv-fp-radio { border-color: var(--srv-primary); }
    .srv-fp-dot { width: 11px; height: 11px; border-radius: 50%; background: transparent; }
    .srv-fp-portion.active .srv-fp-dot { background: var(--srv-primary); }

    .srv-fp-chips { display: flex; flex-wrap: wrap; gap: var(--srv-sm); }
    .srv-fp-chip {
        min-height: var(--srv-tap); padding: 0 18px;
        background: var(--srv-surface); color: var(--srv-on);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r-chip);
        font-family: inherit; font-size: 15px; font-weight: 600; cursor: pointer;
    }
    .srv-fp-chip.active { border-color: var(--srv-primary); color: var(--srv-primary); background: var(--srv-primary-soft); }

    .srv-fp-ing {
        display: flex; align-items: center; justify-content: space-between; gap: var(--srv-sm);
        padding: 8px 0; border-bottom: 1px dashed var(--srv-outline-variant);
    }
    .srv-fp-ing:last-child { border-bottom: none; }
    .srv-fp-ing-nom { flex: 1; min-width: 0; font-size: 15px; font-weight: 600; }
    .srv-fp-ing-choix { display: flex; gap: 6px; flex-shrink: 0; }
    .srv-fp-ing-btn {
        min-width: 66px; min-height: var(--srv-tap); padding: 0 10px;
        background: var(--srv-surface); color: var(--srv-on-variant);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r-input);
        font-family: inherit; font-size: 13px; font-weight: 700; cursor: pointer;
    }
    .srv-fp-ing-btn.active { border-color: var(--srv-primary); color: var(--srv-primary); background: var(--srv-primary-soft); }
    .srv-fp-ing-btn.sans.active { border-color: var(--srv-error); color: var(--srv-error); background: var(--srv-error-soft); }
    .srv-fp-ing-btn.double.active { border-color: var(--srv-warn-on); color: var(--srv-warn-on); background: var(--srv-warn-soft); }

    .srv-fp-bloc textarea {
        width: 100%; padding: 12px 14px; resize: vertical;
        background: var(--srv-surface); color: var(--srv-on);
        border: 1px solid var(--srv-border-fort); border-radius: var(--srv-r-input);
        font-family: inherit; font-size: 16px; outline: none;
    }
    .srv-fp-bloc textarea::placeholder { color: var(--srv-outline); }
    .srv-fp-bloc textarea:focus { border-color: var(--srv-primary); }

    .srv-fp-cta {
        display: flex; align-items: center; gap: var(--srv-sm); flex-shrink: 0;
        padding: var(--srv-sm) var(--srv-gutter);
        border-top: 1px solid var(--srv-outline-variant);
        background: var(--srv-surface);
    }
    .srv-fp-stepper {
        display: flex; align-items: center; flex-shrink: 0;
        background: var(--srv-surface); border: 1px solid var(--srv-outline-variant);
        border-radius: var(--srv-r);
    }
    .srv-fp-stepper button {
        width: var(--srv-tap); height: var(--srv-tap);
        background: none; border: none; color: var(--srv-primary);
        font-size: 20px; cursor: pointer;
    }
    .srv-fp-stepper span { min-width: 28px; text-align: center; font-size: 17px; font-weight: 800; }

    .srv-fp-ajouter { flex: 1; }
    .srv-fp-sep { opacity: .6; }
    .srv-fp-err {
        margin: 0; padding: 0 var(--srv-gutter) var(--srv-sm);
        background: var(--srv-surface);
        font-size: 12px; color: var(--srv-outline); text-align: center;
    }
</style>
